import React from 'react';

import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';

import Header from '../../components/Header/Header';

import useStyles from './Style';

import Layout from '../../layouts/public/Public';

const Privacidade = () => {
    const classes = useStyles();
    return (
        <Layout title="Aviso de Privacidade">
            <Header />

            <Container maxWidth="xl" className={classes.container} >
                <Grid container>
                    <Grid item xs={12} sm={12} lg={12} xl={12} >
                        <iframe 
                            src="https://cdn.impa.br/files/aviso-privacidade/index-nf.html" 
                            className={classes.iframe}
                            title="Aviso Externo de Privacidade"
                        />
                    </Grid>
                </Grid>
            </Container>
        </Layout>
    )
}

export default Privacidade;